import Vue from 'vue';
window.Vue = Vue;

export const EventBus = new Vue();

